import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useLazyLoading from "../../hooks/useLazyLoading";
import { fetchWithTimeout } from "../../hooks/useFetchWithTimeout";

//CSS
import "./trafficView.css";
import "../../Pages/0PageStyles.css";

//Components
import Title from "../Other Components/Title";
import SearchBar from "../Other Components/searchBar";
import ItemCardHeader from "../Item Components/itemCardHeader";
import ItemCard from "../Item Components/itemCard";
import SortComponent from "../Other Components/sortComponent";
import Filter from "../Other Components/filter";
import Button from "../Other Components/button";
import {
  SelectionCategory,
  SliderCategory,
} from "../Other Components/Category";
import PageLoader from "../Other Components/pageLoader";
import ExportData from "../Other Components/ExportDataComponent";

//Functions and hooks
import {
  GetNotes,
  GetNotesInWarehouse,
  CheckForNote,
  GetNotePriceMinMax,
  GetColumnValues,
} from "../../BackendAccess/TrafficHooks";
import { GetWarehouseMap } from "../../BackendAccess/WarehouseHooks";
import { GetClientData, GetClients } from "../../BackendAccess/ClientHooks";
import { useNotification } from "../../Contexts/NotificationContext";
import { useErrorHandler } from "../../hooks/errorHandler";
import { compareDateTimes } from "../../BackendAccess/FrontendHelpers";
import useNarrowMode from "../../hooks/useNarrowModeChecker";
import { useTranslation } from "react-i18next";

export default function TrafficView({
  bEnableSort = true,
  bEnableFilter = true,
  bEnableSearch = true,
  bEnableCreate = true,
  bEnableEdit = true,
  bShowHeader = true,
  bShowTitle = true,
  bShowAll = false,
  bLazyLoading = true,
  btnSectionWidth = 1,
  propertiesToShow = {
    ID: { Show: true, Width: 3 },
    Type: { Show: true, Width: 2 },
    Warehouse: { Show: true, Width: 2 },
    Client: { Show: true, Width: 2 },
    Price: { Show: true, Width: 1 },
    Discount: { Show: false, Width: 1 },
    DateTime: { Show: true, Width: 2 },
  },
  ID = 0,
  onLoaded,
}) {
  const lazyLoadItemLoadCount = 20;
  const lazyLoadPixelThreshold = 100;

  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pageError, setPageError] = useState(null);

  const [categoryArray, setCategoryArray] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const columnWidths = Object.values(propertiesToShow).map(
    (item) => item.Width
  );

  const [PriceLimits, setPriceLimits] = useState([]);
  const [types, setTypes] = useState([]);
  const [warehouses, setWarehouses] = useState(new Map());
  const [clients, setClients] = useState(new Map());
  const [searchFilteredItems, setSearchFilteredItems] = useState([]);

  const { showNotification } = useNotification();
  useErrorHandler(error, showNotification, setPageError);
  const isNarrow = useNarrowMode();

  const { t } = useTranslation();

  ////////////////////////////////////Effects/////////////////////////////////////////////

  const fetchDataFromServer = async () => {
    setLoading(true);
    try {
      await fetchItems();

      await fetchWarehouses();

      await fetchTypes();

      await fetchClients();

      await fetchNotePriceLimit();
    } catch (error) {
      error.isPageError = true;
      setError(error);
    } finally {
      setLoading(false);
    }
  };
  // Fetch items from the server
  const fetchItems = async () => {
    const [data, error] = await fetchWithTimeout(
      bShowAll ? GetNotes : () => GetNotesInWarehouse(ID)
    );
    if (error) {
      throw error;
    }
    setItems(
      data.map((item) => {
        return {
          ...item,
          ...(item.Client ? { Client: item.Client } : { Client: "No Client" }),
        };
      })
    );
  };

  const fetchTypes = async () => {
    const [data, error] = await fetchWithTimeout(() => GetColumnValues("Type"));
    if (error) {
      throw error;
    }
    const typesArrMapped = data.map((item) => {
      return item.Type;
    });
    setTypes(typesArrMapped);
  };

  const fetchWarehouses = async () => {
    const [data, error] = await fetchWithTimeout(() => GetWarehouseMap());
    if (error) {
      throw error;
    }

    setWarehouses(data);
  };

  const fetchClients = async () => {
    const [data, error] = await fetchWithTimeout(() =>
      GetColumnValues("Client")
    );
    if (error) {
      throw error;
    }
    const [clientData, clientDataError] = await fetchWithTimeout(GetClients);
    if (clientDataError) {
      throw clientDataError;
    }

    const clientMap = new Map();
    // Fetch client names
    data.map(async (client) => {
      const clientID = client.Client;

      const clientName = clientID
        ? clientData.find((client) => {
            return client.ClientID === clientID;
          }).Name
        : "No Client";

      clientMap.set(clientName, clientID ? clientID : "No Client");
    });
    setClients(clientMap);
  };

  const fetchNotePriceLimit = async () => {
    const [data, error] = await fetchWithTimeout(
      bShowAll ? () => GetNotePriceMinMax(-1) : () => GetNotePriceMinMax(ID)
    );
    if (error) {
      throw error;
    }
    setPriceLimits(data);
  };

  useEffect(() => {
    fetchDataFromServer();
  }, []);

  useEffect(() => {
    console.log(
      "categories TrafficView useEffect",
      types,
      warehouses,
      clients,
      PriceLimits,
      types.length > 0,
      warehouses.size > 0,
      clients.size > 0,
      PriceLimits.length > 0
    );
    if (
      types.length > 0 &&
      warehouses.size > 0 &&
      clients.size > 0 &&
      PriceLimits.max > 0
    ) {
      createCategoryArray();
    }
  }, [types, warehouses, clients, PriceLimits]);

  useEffect(() => {
    if (items.length > 0) setFilteredItems(items);
  }, [items]);

  ////////////////////////////////////Effects end/////////////////////////////////////////////

  ///////////////////////////////////Filtering//////////////////////////////////////////////////

  function getKeyByValue(map, value) {
    console.log("TESTINGSSADSA getKeyByValue", map, value);
    const entry = Array.from(map.entries()).find(([key, val]) => val === value);
    return entry ? entry[0] : null;
  }

  const createCategoryArray = () => {
    console.log("categories newCatArr init");

    const newCatArr = [
      new SelectionCategory(
        "Type of note",
        types.map((item) => {
          return { ItemName: item, selected: false };
        }),
        false,
        NoteHasOptionType,
        true
      ),
      new SelectionCategory(
        "Warehouse",
        Array.from(warehouses.values()).map((item) => {
          return { ItemName: item, selected: false };
        }),
        false,
        NoteHasOptionWarehouse
      ),
      new SelectionCategory(
        "Client",
        Array.from(clients.keys()).map((item) => {
          return { ItemName: item, selected: false };
        }),
        false,
        NoteHasOptionClient
      ),
      new SliderCategory(
        "Price",
        Number(PriceLimits.min),
        Number(PriceLimits.max),
        2,
        false,
        NoteHasOptionPrice
      ),
    ];
    console.log("categories newCatArr", newCatArr);
    setCategoryArray(newCatArr);
  };

  const NoteHasOptionType = (item, type) => {
    return item.Type === type;
  };
  const NoteHasOptionWarehouse = (item, warehouse) => {
    return item.Warehouse === getKeyByValue(warehouses, warehouse);
  };
  const NoteHasOptionClient = (item, client) => {
    return item.Client === clients.get(client);
  };
  const NoteHasOptionPrice = (item, priceMin, priceMax) => {
    return item.Price >= priceMin && item.Price <= priceMax;
  };

  const setNewCategoryArray = (newCategoryArray) => {
    setCategoryArray(newCategoryArray);
  };

  const setNewItems = (newItems) => {
    setFilteredItems(newItems);
  };

  ////////////////////////////////////Filtering end////////////////////////////////////////////////

  /////////////////////////////////SEARCHING AND SORTING/////////////////////////////////////////
  // Handle search input
  const handleSearchChange = (term) => {
    setSearchTerm(term);
  };

  // Filter items based on search term
  useEffect(() => {
    const newSearchFilteredItems = filteredItems.filter((item) => {
      const lowerCaseTerm = searchTerm.toLowerCase();
      return item.TrafficID.toString().toLowerCase().includes(lowerCaseTerm);
    });
    setSearchFilteredItems(newSearchFilteredItems);
  }, [searchTerm, filteredItems]);

  const typeSortFunction = (direction) => {
    var itemsSorted = [...filteredItems].sort((a, b) =>
      a.Type.toUpperCase() > b.Type.toUpperCase()
        ? direction * 1
        : -1 * direction
    );
    setItems(itemsSorted);
  };
  const idSortFunction = (direction) => {
    var itemsSorted = [...filteredItems].sort((a, b) =>
      a.TrafficID > b.TrafficID ? direction * 1 : -1 * direction
    );
    setItems(itemsSorted);
  };
  const priceSortFunction = (direction) => {
    var itemsSorted = [...filteredItems].sort((a, b) =>
      parseFloat(a.Price) > parseFloat(b.Price) ? direction * 1 : -1 * direction
    );
    setItems(itemsSorted);
  };
  const warehouseSortFunction = (direction) => {
    var itemsSorted = [...filteredItems].sort((a, b) => {
      const newA = warehouses.get(a.Warehouse).toString().toUpperCase();
      const newB = warehouses.get(b.Warehouse).toString().toUpperCase();
      return newA > newB ? direction * 1 : -1 * direction;
    });
    setItems(itemsSorted);
  };
  const clientSortFunction = (direction) => {
    var itemsSorted = [...filteredItems].sort((a, b) => {
      const newA = getKeyByValue(clients, a.Client).toString().toUpperCase();
      const newB = getKeyByValue(clients, b.Client).toString().toUpperCase();
      return newA > newB ? direction * 1 : -1 * direction;
    });
    setItems(itemsSorted);
  };

  const dateTimeSortFunction = (direction) => {
    var itemsSorted = [...filteredItems].sort(
      (a, b) => compareDateTimes(a.DateTime, b.DateTime) * direction
    );
    setItems(itemsSorted);
  };
  ////////////////////////////////////////SEARCHING AND SORTING END//////////////////////////////////////

  ////////////////////////////////////////////////Lazy loading///////////////////////////////////////
  const { loadedItems, itemContainerRef } = useLazyLoading(
    searchFilteredItems,
    lazyLoadItemLoadCount,
    lazyLoadPixelThreshold
  );
  useEffect(() => {
    console.log("Traffic loaded item num", loadedItems.length);
  }, [loadedItems]);
  ////////////////////////////////////////////////Lazy loading end///////////////////////////////////////

  /////////////////////////////////////////Handle btn clicks////////////////////////////////////////
  const handleEditClick = async (id) => {
    const bItemExists = await CheckForNote(id);
    if (bItemExists) {
      navigate("/workspace/traffic/noteViewPage", { state: { id } });
    } else {
    }
  };
  const handleCreateClick = async () => {
    navigate("/workspace/traffic/noteCreationPage");
  };
  /////////////////////////////////////////Handle btn clicks end////////////////////////////////////////

  ////////////////////////////////////////Creating cards///////////////////////////////////////////
  const createHeaderCardProps = () => {
    const cardPropArray = [
      { Value: "ID", columnWidth: columnWidths[0] },
      ...(isNarrow ? [] : [{ Value: "Type", columnWidth: columnWidths[1] }]),
      { Value: "Warehouse", columnWidth: columnWidths[2] },
      ...(isNarrow ? [] : [{ Value: "Client", columnWidth: columnWidths[3] }]),
      { Value: "Price", columnWidth: columnWidths[4] },
      { Value: "Discount", columnWidth: columnWidths[5] },
      ...(isNarrow
        ? []
        : [{ Value: "DateTime", columnWidth: columnWidths[6] }]),
    ];

    const newCardPropArr = cardPropArray.filter((item) => {
      return propertiesToShow[item.Value].Show;
    });
    return newCardPropArr;
  };
  const createCardProps = (item) => {
    const cardPropArray = [
      { Name: "ID", Value: item.TrafficID, columnWidth: columnWidths[0] },
      ...(isNarrow
        ? []
        : [{ Name: "Type", Value: item.Type, columnWidth: columnWidths[1] }]),
      {
        Name: "Warehouse",
        Value: warehouses.get(item.Warehouse),
        columnWidth: columnWidths[2],
      },
      ...(isNarrow
        ? []
        : [
            {
              Name: "Client",
              Value: getKeyByValue(clients, item.Client),
              columnWidth: columnWidths[3],
            },
          ]),
      { Name: "Price", Value: item.Price, columnWidth: columnWidths[4] },
      { Name: "Discount", Value: item.Discount, columnWidth: columnWidths[5] },
      ...(isNarrow
        ? []
        : [
            {
              Name: "DateTime",
              Value: item.DateTime,
              columnWidth: columnWidths[6],
            },
          ]),
    ];

    const newCardPropArr = cardPropArray.filter((item) => {
      return propertiesToShow[item.Name].Show;
    });
    return newCardPropArr;
  };

  ////////////////////////////////////////Creating cards end///////////////////////////////////////////

  return (
    <PageLoader loading={loading} error={pageError}>
      <div className="item-view-container">
        {bShowTitle ? <Title>Traffic</Title> : null}
        <div className="btn-container fill space-between">
          {isNarrow ? null : (
            <div className="btn-container start">
              <Button
                btnStyle={"btn-positive"}
                className="mb-2"
                onClick={handleCreateClick}
                icon={"create"}
              >
                {t("Create new note", { ns: "traffic" })}
              </Button>
            </div>
          )}
        </div>
        {bEnableSearch ? (
          <div className="search-bar-container">
            <SearchBar
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
              placeholder={t("Search traffic...", { ns: "traffic" })}
            />
          </div>
        ) : null}
        <div className="sortAndFilterBar">
          {bEnableSort ? (
            <SortComponent
              sortOpts={[
                "ID",
                "Type",
                "Warehouse",
                "Client",
                "Price",
                "Date/Time",
              ]}
              sortOptFunctions={[
                idSortFunction,
                typeSortFunction,
                warehouseSortFunction,
                clientSortFunction,
                priceSortFunction,
                dateTimeSortFunction,
              ]}
            />
          ) : null}
          {bEnableFilter ? (
            <Filter
              categoryArray={categoryArray}
              ConstItems={items}
              Items={filteredItems}
              setNewItems={setNewItems}
              setNewCatArr={setNewCategoryArray}
            />
          ) : null}
        </div>
        <div className="item-card-and-header-container">
          {bShowHeader ? (
            <ItemCardHeader
              propertiesToShow={createHeaderCardProps()}
              bBtnVisible={false}
              bBtnSectionVisible={bEnableEdit}
              btnSectionWidth={btnSectionWidth}
            />
          ) : null}

          <div className="item-card-container" ref={itemContainerRef}>
            {loadedItems.map((item, index) => (
              <ItemCard
                bEditEnabled={bEnableEdit}
                key={index}
                ItemID={item.TrafficID}
                propertiesToShow={createCardProps(item)}
                bBtnVisible={bEnableEdit}
                bBtnSectionVisible={bEnableCreate || bEnableEdit}
                btnSectionWidth={btnSectionWidth}
                onClick={() => {
                  handleEditClick(item.TrafficID);
                }}
                btnText={t("View")}
                disabled={loading}
              />
            ))}
          </div>
          {bEnableCreate && isNarrow ? (
            <div className="item-view-narrow-btn-container">
              <Button
                btnStyle={"btn-positive"}
                icon="create"
                onClick={handleCreateClick}
              >
                {t("Create")}
              </Button>
            </div>
          ) : null}
        </div>
        {<ExportData data={searchFilteredItems} />}
      </div>
    </PageLoader>
  );
}
